import { render, staticRenderFns } from "./ConfirmModalNew.vue?vue&type=template&id=0736ed4c&"
import script from "./ConfirmModalNew.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports